import './App.css';
import HomePage from './Homepage/homepage';

function App() {
  return (
    <div className="App">
      <HomePage />
    </div>
  );
}

export default App;
